import React from 'react';
import clsx from 'clsx';

import {Box, Container, CssBaseline, Grid, Typography} from '@material-ui/core';

import Copyright from '../../components/CopyRight';
import ManabieLogo from '../../components/ManabieLogo';

import {useTranslation} from 'react-i18next';
import useStyles from './styles';

export interface MainLayoutProps {
  children: React.ReactNode | React.ReactNode[],
  isContentCentered?: boolean
  title: string,
  miniHref: string
  miniText: string
}


const AccountLayout = (props: MainLayoutProps) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const containerClasses = clsx(classes.container, props.isContentCentered && classes.center);

  return (
    <div className={classes.wrapper}>
      <Container
        className={containerClasses}
        component="main"
        maxWidth="lg"
      >
        <div className={classes.paper}>
          <CssBaseline/>
          <div className={classes.formTitle}>
            <ManabieLogo />
            <Typography className={classes.welcome}>
              {t(props.title)}
            </Typography>
          </div>
          {props.children}
          <Grid container>
            <Grid item xs>
              <a href={props.miniHref}>
                {t(props.miniText)}
              </a>
            </Grid>
          </Grid>
        </div>
        <Box mt={8}>
          <Copyright/>
        </Box>
      </Container>
    </div>
  )
};

AccountLayout.defaultProps = {
  isContentCentered: true
};

export default AccountLayout